import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, setLogLevel } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC42IM8gqZarkv0C6xf39XIxRLPhAwrVuY",
  authDomain: "segurawatch.firebaseapp.com",
  projectId: "segurawatch",
  storageBucket: "segurawatch.appspot.com",
  messagingSenderId: "76674777420",
  appId: "1:76674777420:web:d00e47f3bf6ca88736cfe9"
};

const app = initializeApp(firebaseConfig);

// Suppress Firestore WebChannel transport warnings (normal reconnect behavior)
setLogLevel("error");

export const auth           = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app, "watch");